
<script setup>
import CreateNotebookDrawer from '@/views/notebooks/CreateNotebookDrawer.vue'
import moment from "moment";
import axios from '@/helpers/axios'

definePage({
  meta: {
    layout: 'default',
    role: 'user'
  },
})

const notebooks = ref([])

// const selfUser = ref(JSON.parse(localStorage.getItem('user')))
const showCreateNotebookDrawer = ref(false)

const getNotebooks = () => {
  axios.get('/notebooks').then(r => {
    notebooks.value = r.data.data
  }).catch(e => {
    console.error(e)
  })
}

getNotebooks()
</script>

<template>
  <div>
    <div class="page-header mb-4">
      <div class="d-flex flex-column flex-sm-row align-sm-center justify-space-between gap-4">
        <div>
          <h2 class="text-h4 font-weight-semibold mb-2 text-high-emphasis">
            {{ $t('notebooks.title') }}
          </h2>
          <p class="text-body-1 text-medium-emphasis mb-0">
            {{ $t('notebooks.description') }}
          </p>
        </div>

        <VBtn
          color="primary"
          class="text-none px-5 py-3 font-weight-medium"
          size="large"
          rounded="lg"
          variant="tonal"
          @click="showCreateNotebookDrawer = true"
        >
          <VIcon start icon="tabler-plus" size="20" />
          {{ $t('notebooks.create') }}
        </VBtn>
      </div>
    </div>

    <VRow v-if="notebooks.length" class="match-height">
      <VCol
        v-for="notebook in notebooks"
        :key="notebook.uuid"
        cols="12"
        md="6"
        lg="4"
      >
        <VCard
          class="overflow-visible pa-4 group-card"
          style="border-radius: 16px;"
          elevation="2"
        >
          <!-- Header -->
          <div class="d-flex justify-space-between align-start mb-4 flex-wrap gap-3">
            <div class="d-flex align-center gap-3">
              <VAvatar
                color="primary"
                variant="tonal"
                size="44"
                class="text-h6 font-weight-semibold"
              >
                {{ notebook.name?.charAt(0)?.toUpperCase() }}
              </VAvatar>
              <div>
                <h4 class="text-h5 font-weight-semibold mb-1 text-high-emphasis">
                  {{ notebook.name }}
                </h4>
                <p class="text-caption text-medium-emphasis mb-0">
                  {{ formatDate(notebook.last_entry) }}
                </p>
              </div>
            </div>

            <VBtn
              icon
              size="small"
              variant="tonal"
              color="primary"
              :to="{ name: 'notebooks-uuid', params: { uuid: notebook.uuid } }"
            >
              <VIcon icon="tabler-arrow-right" size="x-large" />
              <VTooltip activator="parent" location="top">
                {{ $t('layout.open') }}
              </VTooltip>
            </VBtn>
          </div>

          <!-- Middle section -->
          <div class="mb-4">
            <div class="d-flex align-center mb-1">
              <VIcon icon="tabler-note" size="18" class="me-2 text-primary" />
              <span class="text-body-2 text-medium-emphasis">
                {{ $t('notebooks.notes_number', { number: notebook.notes }) }}
              </span>
            </div>

          </div>
        </VCard>
      </VCol>
    </VRow>
    <div v-else>
      <div
        class="d-flex flex-column align-center justify-center text-center flex-grow-1 py-10"
      >
        <VIcon icon="tabler-notebook-off" size="48" color="grey" class="mb-3" />
        <h4 class="text-h6 font-weight-medium text-high-emphasis mb-1">
          {{ $t('notebooks.no_notebooks') }}
        </h4>
      </div>
    </div>
    <CreateNotebookDrawer
      :is-drawer-open="showCreateNotebookDrawer"
      @update:is-drawer-open="(val) => showCreateNotebookDrawer = val"
      @submit="getNotebooks"
    />
  </div>
</template>

<style scoped>
.page-header {
  background: linear-gradient(180deg, var(--v-theme-surface), transparent);
  border-radius: 16px;
  padding: 1.5rem 0rem;
  transition: all 0.25s ease;
}

@media (max-width: 600px) {
  .page-header {
    padding: 1.25rem 1rem;
  }
  .page-header h2 {
    font-size: 1.4rem;
  }
}

.group-card {
  transition: all 0.25s ease;
}

.group-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  border-color: var(--v-theme-primary);
}
</style>
